import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const StatisticsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  height: calc(100vh - ${pxToRem(54)}); /* Занимает всю высоту экрана с учетом отступов */
  box-shadow:
    0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  overflow-x: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${pxToRem(250)}, 1fr)); /* Адаптивная сетка */
  gap: ${pxToRem(24)};
`;

export const ChartWrapper = styled.div`
  margin-top: ${pxToRem(32)};
  padding: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  height: calc(100% - ${pxToRem(32)});
  box-shadow:
    0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);

  .recharts-wrapper {
    height: 100%;
  }
`;

export const ModeSwitchContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  margin-bottom: ${pxToRem(16)};
`;

export const ModeButton = styled.button<{ isActive: boolean }>`
  padding: ${pxToRem(8)} ${pxToRem(16)};
  border-radius: ${pxToRem(8)};
  border: none;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? "#724EDC" : "#e0e0e0")};
  color: ${({ isActive }) => (isActive ? "white" : "#333")};
  font-size: ${pxToRem(14)};
  font-weight: 600;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#5a3bba" : "#d0d0d0")};
  }
`;
